export * from '@primeuix/themes/lara/virtualscroller';
export { default } from '@primeuix/themes/lara/virtualscroller';
